import React from 'react';
import { Chip, useFrozen as useFrozenCols } from '../attendance/shared';

// Leave Management (Stephanet's leavemgmt/shared.jsx): shared labels, formats and small parts

export const STATUS_TONE = {
  draft: 'gray', pending: 'yellow', pre_approved: 'blue', approved: 'green', rejected: 'red', returned: 'orange', cancelled: 'gray', closed: 'teal',
};
export const STATUS_LABEL = {
  draft: 'Draft', pending: 'Pending', pre_approved: 'Pre Approved', approved: 'Approved', rejected: 'Rejected', returned: 'Returned for Correction',
  cancelled: 'Cancelled',
};
export const WAITING = ['pending', 'pre_approved'];
export const MON_TONE = { pending: 'yellow', approved: 'green', rejected: 'red', returned: 'orange' };
export const PAY_TONE = { 'Posted to Payroll': 'green', Paid: 'teal', 'Awaiting Approval': 'yellow', 'Not Posted': 'gray' };

export const StatusChip = ({ s }) => <Chip tone={STATUS_TONE[s]}>{STATUS_LABEL[s] || s}</Chip>;
export const TypeChip = ({ t }) => <span className="lvm-type">{String(t || '').toUpperCase()}</span>;

// 2025-03-02 -> 02/03/25 (as the reference shows dates)
export const dmy = s => (s ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(2, 4)}` : '—');
export const longDate = s => (s ? new Date(`${s.slice(0, 10)}T00:00:00`).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');
export const num = v => (v === null || v === undefined ? '—' : Number(v).toLocaleString(undefined, { maximumFractionDigits: 1 }));
export const monthName = m => (m ? new Date(`${m}-01T00:00:00`).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' }) : '—');

// the leave type's id from its name (the screens pick types by name, as the reference does)
export const typeId = (data, name) => data.types.find(t => t.name === name)?.id;

// working days between two ISO dates (weekdays less holidays), as the server counts them
export function workingDays(start, end, holidays = {}) {
  if (!start || !end || end < start) return 0;
  let n = 0;
  const d = new Date(`${start}T00:00:00`);
  const last = new Date(`${end}T00:00:00`);
  while (d <= last) {
    const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    if (d.getDay() % 6 !== 0 && !holidays[iso]) n += 1;
    d.setDate(d.getDate() + 1);
  }
  return n;
}

export const payrollImpact = r => (r.status === 'approved'
  ? (r.paid ? 'Paid - No Deduction' : 'Unpaid - Salary Deduction')
  : WAITING.includes(r.status) ? 'Pending' : '—');

// the first n columns stay in place while a wide table scrolls sideways
export const useFrozen = (n, deps) => useFrozenCols(deps, n);

export const Empty = ({ children, cols }) => <tr><td colSpan={cols} className="mdr-empty">{children}</td></tr>;

// a run of tab buttons (the Advanced Dashboard's inner tabs and the sub-views under it)
export function InnerTabs({ items, active, onChange, sub, children }) {
  return (
    <div className={`lvm-inner ${sub ? 'lvm-inner-sub' : ''} no-print`} role="tablist">
      {items.map(([k, l, I]) => <button key={k} type="button" role="tab" className={active === k ? 'active' : ''} onClick={() => onChange(k)}><I size={13} /> {l}</button>)}
      {children}
    </div>
  );
}
